<template>
  <div class="w-full rounded-lg mb-4 px-4 py-2" :class="required_banner_class" v-if="!is_disabled">
    <div class="flex items-center">
      <Icon name="Asterisk" class="-skew-x-12 text-error min-h-4 min-w-4 h-4 w-4 mr-1" />
      <div class="text-sm font-semibold font-inter text-error">Indicates a required field</div>
    </div>
  </div>
  <div class="grid grid-cols-6 gap-3">
    <div
      v-for="(schema, idx) in schema_array"
      :key="`${schema.field_name}-${schema.read_only}-${idx}`"
      :class="getSchemaWrapperClass(schema)"
    >
      <BaseInput
        :record_id="record_id"
        :label="schema.label"
        :field_name="schema.field_name"
        :field_type="schema.field_type"
        :read_only="schema.read_only || props.is_disabled"
        :number_type="schema.number_type"
        v-model="props.state_object[schema.field_name]"
        :additional_info="schema.additional_info"
        :is_secure_field="schema.is_secure_field"
        :variant="props.variant"
        :max_length="schema.max_length"
        :is_required="schema.is_required"
        :record_detail_group="schema.record_detail_group"
        :belongs_to_nested_object="schema.belongs_to_nested_object"
        :nested_object_name="schema.nested_object_name"
        :dropdown_above="
          dropdown_above && schema_array.length > 4 && idx >= schema_array.length - 2
        "
        :place_holder="schema.place_holder"
        :dropdown_options="
          schema.field_name === 'state' || schema.field_name === 'ma_state'
            ? US_STATES
            : schema?.dropdown_options
        "
        :object_type="object_type"
        :error_message="errors[schema.field_name] || ''"
      />
    </div>
  </div>
</template>

<script setup>
import { BaseInput, Icon, AsteriskNotice } from "../components";
import { US_STATES } from "@/constants";
import { computed } from "vue";

const props = defineProps({
  variant: { type: String, default: "primary" },
  is_disabled: { type: Boolean, default: false },
  schema_array: { type: Array, required: true },
  state_object: { type: Object, required: true },
  record_id: { type: String, default: null },
  object_type: { type: String, default: null },
  errors: { type: Object, default: () => ({}) },
  dropdown_above: { type: Boolean, default: true },
});

const COL_SPAN = {
  1: "col-span-1",
  2: "col-span-2",
  3: "col-span-3",
  4: "col-span-4",
  5: "col-span-5",
  6: "col-span-6",
};

const MD_COL_SPAN = {
  1: "md:col-span-1",
  2: "md:col-span-2",
  3: "md:col-span-3",
  4: "md:col-span-4",
  5: "md:col-span-5",
  6: "md:col-span-6",
};

const getSchemaWrapperClass = (schema) => {
  const mobile = schema.mobile_col_span ?? 6;
  const desktop = schema.desktop_col_span ?? 3; // (you probably want 2 as default)
  return [COL_SPAN[mobile], MD_COL_SPAN[desktop]];
};

const required_banner_class = computed(() => {
  return props.variant === "primary" ? "bg-bg-canvas" : " bg-container-bg";
});
</script>
